import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M11.003 13.308a.446.446 0 0 1-.438.438.446.446 0 0 1-.437-.438V7.705c0-.235.202-.437.437-.437.236 0 .438.202.438.437zm-2.557 0a.445.445 0 0 1-.438.438.446.446 0 0 1-.437-.438V7.705c0-.235.202-.437.437-.437.236 0 .438.202.438.437zm-2.558 0a.446.446 0 0 1-.437.438.446.446 0 0 1-.438-.438V7.705c0-.235.202-.437.438-.437.235 0 .437.202.437.437zm7.672-8.934H2.456a.646.646 0 0 0-.656.656c0 .37.286.657.656.657h.303v8.984c0 .723.589 1.312 1.312 1.312h7.89c.724 0 1.313-.589 1.313-1.312V5.687h.286c.37 0 .656-.286.656-.657a.647.647 0 0 0-.656-.656M8.008.875c.505 0 .926.303 1.11.723-.37-.017-.74-.033-1.11-.033-.387 0-.757.016-1.11.033a1.21 1.21 0 0 1 1.11-.723M2.254 3.584h11.508c.438 0 .623-.59.236-.825-.926-.589-2.322-.925-3.937-1.077A2.11 2.11 0 0 0 8.008 0a2.11 2.11 0 0 0-2.052 1.666c-1.616.151-3.012.504-3.937 1.076-.387.253-.219.842.235.842" })
    ], -1)
  ]))]))
}
export default { render: render }